
<template>
    <div>
        <mars-view v-if="showSuccess || bindFail"><mars-view class="bg"></mars-view><mars-view v-if="showSuccess" class="content"><mars-view class="icon-succ"></mars-view><mars-view class="title">您已绑定成功</mars-view><mars-view class="sub-title">通过微信服务号及时接收律临通知提醒</mars-view><mars-view class="btn" @click.native="goBHome">返回</mars-view></mars-view><mars-view v-if="bindFail" class="content"><mars-view class="icon-fail"></mars-view><mars-view class="title">绑定失败</mars-view><mars-view class="sub-title sub-title-fail">当前律临账号已与其他微信账号绑定，如需解绑请联系lvlin_help@baidu.com</mars-view><mars-view class="btn btn-fail" @click.native="goBHome">返回</mars-view></mars-view></mars-view>
    </div>
</template>

<script>
/**
 * @file 微信绑定
 */

/* globals getApp, Page, swan */

import log from '../../static/utils/ubcLog';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import { toLoginPage } from '../../static/utils/login';
import { request } from '../../static/utils/request.js';
export default {
  components: {},
  data() {
    return {
      showSuccess: false,
      bindFail: false
    };
  },
  methods: {
    goBHome() {
      window.location.href = 'https://lvlin.baidu.com/saas';
    }
  },
  created() {
    (function (ctx) {
      setPageInfoMenu({
        title: '账号绑定'
      });
      this.queryInfo = ctx || {};
      log.addKey && log.addKey({
        page: 'share',
        ...this.queryInfo
      });
      request({
        url: '/bp/api/wechat/bind',
        method: 'post',
        data: {
          openid: ctx.openid
        },
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        {
          const code = res.data && res.data.code;
          if (+code === 0) {
            this.showSuccess = true;
            return;
          } else if (+code === 10010) {
            toLoginPage();
            return;
          }
          this.bindFail = true;
        }
        this.$api.showToast({
          title: '绑定失败，请刷新页面',
          icon: 'none'
        });
      }).catch(() => {
        this.$api.showToast({
          title: '绑定失败，请刷新页面',
          icon: 'none'
        });
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.bg {
  width: 100%;
  height: 5.44rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/wx/bind-bg.png') no-repeat;
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 7;
}
.content {
  width: 100%;
  height: auto;
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.content .icon-succ,
.content .icon-fail {
  width: 0.7rem;
  height: 0.7rem;
}
.content .icon-succ {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/wx/success.png') no-repeat;
  background-size: 100% 100%;
}
.content .icon-fail {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/wx/bind-fail-icon.png') no-repeat;
  background-size: 100% 100%;
}
.content .title {
  font-family: PingFangSC-Medium;
  font-size: 0.2rem;
  color: #1f1f1f;
  text-align: center;
  line-height: 1;
  margin: 0.2rem 0 0.18rem;
}
.content .sub-title {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #858585;
  text-align: center;
  line-height: 1;
}
.content .sub-title-fail {
  margin: 0 0.3rem;
  line-height: 0.22rem;
  text-align: center;
}
.content .btn {
  width: 3.34rem;
  height: 0.44rem;
  background: #05f;
  border-radius: 0.22rem;
  font-family: PingFangSC-Medium;
  font-size: 0.18rem;
  color: #fff;
  text-align: center;
  line-height: 0.44rem;
  margin-top: 0.4rem;
}
.content .btn-fail {
  margin-top: 0.23rem;
}

</style>
